<div class="header-container">
    <span class="header-title font-bold">{{ title }}</span>
    <span class="header-icons">
        <mat-icon [matMenuTriggerFor]="libMenu">keyboard_arrow_down</mat-icon>
        <mat-icon [matTooltip]="'UNPIN' | translate" (click)="unpinLibraryClick()">push_pin</mat-icon>
        <mat-icon [matTooltip]="'CLOSE' | translate" (click)="closeLibraryClick()">close</mat-icon>
    </span>
</div>
<mat-menu #libMenu="matMenu">
    <span class="lib-menu-item" mat-menu-item [disabled]="true">{{'DOCK' | translate}}</span>
    <span class="lib-menu-item" mat-menu-item (click)="unpinLibraryClick()">{{'AUTO_HIDE' | translate}}</span>
    <span class="lib-menu-item" mat-menu-item (click)="closeLibraryClick()">{{'HIDE' | translate}}</span>
</mat-menu>